import styled from 'astroturf/react'
import { Link } from '@calendly/ui/components/link'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue600))'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'

import { useI18n } from 'locales'
import _StyledLink from "legal_copy-StyledLink.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/scheduling_form_feature/legal_copy.js?styleId=StyledLink";
import _Container from "legal_copy-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/scheduling_form_feature/legal_copy.js?styleId=Container";


const StyledLink = /*#__PURE__*/styled(Link, null, {
  displayName: "StyledLink",
  styles: _StyledLink
})
const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const LegalCopy = () => {
  const { i18n } = useI18n()
  return (
    <Container>
      {`${i18n.t('booking.terms_and_conditions.base_language')} `}
      <StyledLink
        underline={false}
        href="https://calendly.com/legal/invitee-terms-conditions"
        target="_blank"
        rel="related"
      >
        {`${i18n.t('booking.terms_and_conditions.calendly_invitee_terms')} `}
      </StyledLink>
      {` ${i18n.t('booking.terms_and_conditions.and')} `}
      <StyledLink
        underline={false}
        href="https://calendly.com/privacy"
        target="_blank"
        rel="related"
      >
        {` ${i18n.t('booking.terms_and_conditions.privace_notice')}`}
        .
      </StyledLink>
    </Container>
  )
}

export default LegalCopy
